import { createSvgIcon } from '@mui/material/utils';

export const ToggleHeaderRow = createSvgIcon(
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 4H4V20H20V4ZM4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4Z"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M20 15H4V13H20V15Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M20 8H4V6H20V8Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M8 20V4H10L10 20H8Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14 20V4H16V20H14Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M21 7H3V3H21V7Z" />
  </g>,

  'toggleHeaderRow',
);
